import PouchDb from 'pouchdb';
import PouchDbFind from 'pouchdb-find';
import session from '../auth/session';
import store from '../store/store';

PouchDb.plugin(PouchDbFind);

export function buildRemoteDbAddr(ctx, done) {
  switch (ctx) {
    case 'qa':
      done(`${process.env.VUE_APP_COUCH_DB_BASE_URL}/qa`);
      return;
    case 'workspace':
      done(`${process.env.VUE_APP_COUCH_DB_BASE_URL}/qa_workspace`);
      return;
    case 'workspaceAttachments':
      done(`${process.env.VUE_APP_COUCH_DB_BASE_URL}/qa_workspace_attachments`);
      return;
    default:
      throw new (function (ctx) {
        this.message = `Received ${ctx}. Valid contexts are: [qa, workspace, workspaceAttachments].`;
        this.name = 'RemoteDbAddrException';
      })(ctx);
  }
}

export function buildRemoteDbAddrForWorkspace(ctx, workspace) {
  switch (ctx) {
    case 'workspace':
      return `${process.env.VUE_APP_COUCH_DB_BASE_URL}/qa_workspace`;
    case 'workspaceAttachments':
      return `${process.env.VUE_APP_COUCH_DB_BASE_URL}/qa_workspace_attachments`;
    default:
      throw new (function (ctx) {
        this.message = `Received ${ctx}. Valid contexts are: [workspace, workspaceAttachments].`;
        this.name = 'RemoteDbAddrException';
      })(ctx);
  }
}

export class RemoteDb {
  constructor(remoteDbAddr, opts = {}) {
    this.remoteDbAddr = remoteDbAddr;

    if (opts['username'] && opts['password']) {
      this.username = opts['username'];
      this.password = opts['password'];
    } else {
      this.username = store.state.user.username;
      this.password = store.state.user.password;
    }
  }

  db() {
    return new PouchDb(this.remoteDbAddr, {
      auth: {
        username: this.username,
        password: this.password,
      },
    });
  }
}

class LocalDb {
  constructor(localName) {
    this.name = localName;
  }

  db() {
    return new PouchDb(this.name);
  }

  startPull(remoteDb, complete, error) {
    PouchDb.replicate(remoteDb.db(), this.db())
      .on('complete', complete)
      .on('denied', error)
      .on('error', error);
  }

  startPush(remoteDb, complete, error) {
    PouchDb.replicate(this.db(), remoteDb.db())
      .on('complete', complete)
      .on('denied', error)
      .on('error', error);
  }
}

export const qaDb = new LocalDb('qa');
export const workspaceDb = new LocalDb('qa_workspace');
export const workspaceAttachmentsDb = new LocalDb('qa_workspace_attachments');
